import axios from "axios";
import { CreateAddressType } from "../pages/types/CreateAddressType";

export const updateAddress = (
  addressId: number,
  addressDetails: CreateAddressType,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/update/one/tradexwbench.customer_address/${addressId}`,
      {
        params: {
          context: {},
          data: addressDetails,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
